exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-data-table[data-v-4ff08fdb] .sticky-header{position:sticky;top:0;z-index:1}.v-data-table[data-v-4ff08fdb] .v-data-table__wrapper{margin-top:0;overflow:unset}.v-data-table[data-v-4ff08fdb] tr:nth-child(2n){background-color:#fafafa}.v-chip__content[data-v-4ff08fdb]{font-size:12px}.rowWasEdited[data-v-4ff08fdb]{border:2px solid #ab3b7c;padding:2px}", ""]);

// exports
